import {SeparatorContainer} from "./Separator.style";
import {ErrorBoundary} from "react-error-boundary";
import {urlHasParam} from "../../utils/js/params";

function Separator(props) {
  const {separatorHeightDesktop,separatorHeightTablet,separatorHeightMobile, hideLine, isInEditor} = props;
  
  return (
    <SeparatorContainer 
    separatorHeightDesktop={(isInEditor && separatorHeightDesktop === "0") ? 15 : separatorHeightDesktop || 144}
    separatorHeightTablet={(isInEditor && separatorHeightTablet === "0") ? 15 : separatorHeightTablet || 128}
    separatorHeightMobile={(isInEditor && separatorHeightMobile === "0") ? 15 : separatorHeightMobile || 112}
    hideLine={hideLine === undefined ? true : hideLine}>
      <hr className="separator__bar"/>
    </SeparatorContainer>
  );
}

const SeparatorHandleErrors = props => {
  return (
      <ErrorBoundary fallback={props.isInEditor || urlHasParam('wcmmode=disabled') ? <div style={{minHeight: '50px', display: 'flex', alignItems: 'center', backgroundColor: '#ffe1db'}}><p>The separator component is currently experiencing errors. Please try again later.</p></div> : <div></div>}>
          <Separator {...props}/>
      </ErrorBoundary>
  )
}

export default SeparatorHandleErrors;

